<template>
  <HeaderMenu></HeaderMenu>
  <!-- <HeaderMenu v-if="this.UserID>0" :key="this.UserID"></HeaderMenu>
  <HeaderMenuNotLogin v-else :key="this.UserID"></HeaderMenuNotLogin> -->
  <!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div> -->
  <router-view/>
</template>

<script>
import HeaderMenu from './components/HeaderMenu.vue'
// import HeaderMenuNotLogin from './components/HeaderMenuNotLogin.vue'
import { provide, ref } from 'vue'

export default {
  setup () {
    const corpInfo = ref({
      MemberName: 'mylab',
      name: 'คลินิกเทคนิคการแพทย์แล็บสมาร์ท',
      name2: 'LABSMART LAB',
      addr1: '123 หมู่ 8 ถนนกลางเมือง XXXXXXXXXXXXXXXX ',
      addr2: '',
      tambol: 'ต.บ้านสดใส',
      amphor: 'อ.บ้านสดใส',
      province: 'จ.สระบุรี',
      zipcode: '12345',
      tel1: '089-154-4569',
      tel2: '089-154-4570',
      fax: '036-211-888',
      email1: 'infolab@gmail.com',
      email2: 'infolab2@gmail.com',
      logoFile: 'demologo.jpg',
      PackageType: 0,
      PackageDateBegin: null,
      PackageDateEnd: null,
      DateIN: null,
      LeftDays: 0,
      StatusStep: 0
    })
    provide('corpInfo', corpInfo)
    var counter = ref(0)
    var corpID = ref(0)
    var corpName = ref('')
    var userID = ref(0)
    var userName = ref('')
    var userOfficialName = ref('')
    var userPosition = ref('')
    var branchID = ref(0)
    provide('counter', counter)
    provide('corpID', corpID)
    provide('corpName', corpName)
    provide('userID', userID)
    provide('userName', userName)
    provide('userOfficialName', userOfficialName)
    provide('userPosition', userPosition)
    provide('branchID', branchID)
    provide('remoteClinicID', corpID)
    provide('remoteClinicName', corpName)
    return {
      counter, corpID, corpName, userID, userName, userOfficialName, branchID, corpInfo
    }
  },
  name: 'App',
  components: {
    HeaderMenu
  },
  data () {
    return {
      username: ''
    }
  },
  mounted () {
    // if back button is pressed
    // window.onpopstate = function (event) {
    //   alert('location: ' + document.location + ', state: ' + JSON.stringify(event.state))
    // }
  },
  methods: {

  }
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
